import { render, staticRenderFns } from "./PersonalInfoSummary.vue?vue&type=template&id=cd2060f6&scoped=true&"
import script from "./PersonalInfoSummary.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoSummary.vue?vue&type=script&lang=js&"
import style0 from "./PersonalInfoSummary.vue?vue&type=style&index=0&id=cd2060f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2060f6",
  null
  
)

export default component.exports